import type { Vec2 } from "../types";

export const add = (a: Vec2, b: Vec2): Vec2 => [a[0] + b[0], a[1] + b[1]];
export const sub = (a: Vec2, b: Vec2): Vec2 => [a[0] - b[0], a[1] - b[1]];
export const scale = (a: Vec2, factor: number): Vec2 => [a[0] * factor, a[1] * factor];
export const dot = (a: Vec2, b: Vec2): number => a[0] * b[0] + a[1] * b[1];
export const length = (a: Vec2): number => Math.hypot(a[0], a[1]);
export const unit = (a: Vec2): Vec2 => {
  const magnitude = length(a);
  return magnitude > 1e-12 ? scale(a, 1 / magnitude) : [0, 0];
};
export const headingVector = (heading: number): Vec2 => [Math.cos(heading), Math.sin(heading)];
export const clip = (value: number, minimum: number, maximum: number): number => Math.min(maximum, Math.max(minimum, value));
export const cross = (a: Vec2, b: Vec2): number => a[0] * b[1] - a[1] * b[0];
export const cloneVec = (value: Vec2): Vec2 => [value[0], value[1]];
export const rgb = (color: [number, number, number]): string => `rgb(${color[0]} ${color[1]} ${color[2]})`;
